/**
 * @ngdoc directive
 * @name donationformamount
 *
 * @description
 * Donation Form amount
 */
module.directive('donationformamount', function () {
    'use strict';
    return {
        restrict: 'E',
        controller: ['$scope', function ($scope) {

            /* switch handler */
            $scope.switchFrequence = function (value) {
                if (!value) {
                    if ($scope.formModel.frequence === 'unique') {
                        $scope.formModel.frequence = 'mensuel';
                    } else {
                        $scope.formModel.frequence = 'unique';
                    }
                } else {
                    $scope.formModel.frequence = value;
                }
            };

            /* amount explenation handler */
            $scope.changeAmount = function (value) {
                $scope.formModel.montant = parseInt(value);
            };

            /* selected range handler */
            $scope.isCurrentAmount = function (value) {
                return parseInt(value) === $scope.formModel.montant;
            };

            // tax explenation calculation
            $scope.explenationsTax = '';
            $scope.$watchCollection('formModel.montant', function (newValue) {
                /* get reduction explenation */
                var a, b, c;
                if (isNaN($scope.formModel.reduction) || isNaN($scope.formModel.limit_income) || isNaN(newValue) || newValue === 0) {
                    $scope.explenationsTax = '';
                    return;
                }
                a = ($scope.formModel.montant * $scope.formModel.reduction) / 100;
                a = a.toFixed(2);
                b = $scope.formModel.montant - a;
                b = b.toFixed(2);
                c = $scope.formModel.limit_income;
                $scope.explenationsTax = 'Votre don ne vous coûte réellement que <strong>' + b + '€</strong> après réduction fiscale (réduction fiscale de <strong>' + a + '€</strong> à hauteur de ' + c + '% du revenu imposable)';

                /* get text depending on selected amount */
                $scope.explenationsAmount = '';
                $scope.formModel.montants.some(function (montant) {
                    if (parseInt(montant.amount) === newValue) {
                        $scope.explenationsAmount = montant.description;
                        return true;
                    } else {
                        return false;
                    }
                });
            });

            /* amount error detection */
            $scope.hasAmountError = function (model) {
                return $scope.donationForm.$submitted && ($scope.donationForm.amountForm[model].$error.required || $scope.donationForm.amountForm[model].$error.pattern);
            };

        }],
        template:
                '  <section class="aqua-donationform-amount" ng-form="amountForm">' +
                '    <a name="montant"></a>' +
                '    <div class="grid-main">' +
                '      <h2 class="grid grid-center"><span class="aqua-donationform-amount--title">Mon don</span></h2>' +

                '      <div class="grid grid-12">' +

                /* Error warning */
                '        <div class="aqua-form--warning aqua-form--warning-alternate grid-12" ng-if="hasAmountError(\'montant\')">' +
                '          <p class="aqua-form--warning-message">Veuillez renseigner un montant valide.</p>' +
                '        </div>' +

                /* Montant (range) */
                '        <div class="grid-12 grid">' +

                '          <div class="grid-7 grid-12-s grid grid-middle">' +

                '            <ul class="aqua-donationform-amount--range grid-10 pull-1-s">' +
                '              <li class="aqua-donationform-amount--range-item" ng-repeat="montant in formModel.montants" ng-click="changeAmount(montant.amount)" ng-class="{\'is-active\': isCurrentAmount(montant.amount)}">' +
                '                <span class="aqua-donationform-amount--range-text">{{montant.amount}}</span>' +
                '              </li>' +
                '            </ul>' +

                '          </div>' +

                '          <div class="grid-5 grid-12-s">' +
                '            <div class="aqua-donationform-amount--range-explenation" ng-if="explenationsAmount" ng-bind-html="explenationsAmount | trustAsHtml"></div>' +
                '          </div>' +

                '        </div>' +

                /* Montant (field) */
                '        <div class="grid-12 grid">' +

                '          <div class="aqua-form--field grid grid-7 grid-12-s" ng-class="{\'has-error\': hasAmountError(\'montant\')}">' +
                '            <label for="field_montant" class="aqua-form--label aqua-form--label-alternate grid-12">Montant du don (possibilité de saisir une valeur personnalisée)</label>' +

                /* input field */
                '            <div class="aqua-form--input-group aqua-form--input-group-alternate grid-3 grid-4-m grid-6-s pull-3-s grid grid-middle">' +
                '              <input type="number" min="0" class="aqua-form--input aqua-form--input-alternate grid-10 l-tar" id="field_montant" name="montant" ng-model="formModel.montant" pattern="(0*[1-9][0-9]*(\.[0-9]+)?|0+\.[0-9]*[1-9][0-9]*)" required>' +
                '              <span class="aqua-form--input-suffix">€</span>' +
                '            </div>' +

                /* switch */
                '            <div class="grid-7 grid-10-s pull-1-s  grid grid-auto">' +
                '              <span class="aqua-form--switch grid grid-middle">' +
                '                <span class="aqua-form--switch-label aqua-form--switch-label-alternate" ng-click="switchFrequence(\'unique\')">Unique</span>' +
                '                <span class="grid grid-middle" ng-click="switchFrequence()">' +
                '                  <span class="aqua-form--switch-cursor aqua-form--switch-cursor-alternate" ng-class="{\'is-active\': formModel.frequence === \'mensuel\'}"></span>' +
                '                </span>' +
                '                <span class="aqua-form--switch-label aqua-form--switch-label-alternate" ng-click="switchFrequence(\'mensuel\')">Mensuel</span>' +
                '              </span>' +
                '            </div>' +

                '          </div>' +

                '          <div class="grid-5 grid-12-s grid grid-bottom">' +
                '            <p class="aqua-donationform-amount--tax" ng-bind-html="explenationsTax | trustAsHtml"></p>' +
                '          </div>' +

                '        </div>' +


                /* Destination */
                '        <div class="grid grid-12">' +
                '          <div class="aqua-form--field grid-12">' +

                '            <p class="aqua-form--label aqua-form--label-alternate grid-12">A destination</p>' +

                '            <div class="aqua-form--checkboxes_deprecated aqua-form--checkboxes_deprecated-alternate grid-10 grid-12-s grid grid-between">' +
                '              <label class="aqua-form--checkbox_deprecated-label grid-12-s" ng-repeat="destination in formModel.destinations" ng-class="{\'is-active\': destination.checked}"><input type="checkbox" class="aqua-form--checkbox_deprecated" name="destination_{{destination.id}}" ng-model="destination.checked"> <span class="aqua-form--checkbox_deprecated-text">{{destination.label}}</span></label>' +
                '            </div>' +

                '          </div>' +
                '        </div>' +

                '      </div>' +

                '    </div>' +
                '  </section>'
    };
});